/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_pagination__aria_labels__prev = /** @type {(inputs: {}) => string} */ () => {
	return `Vorherige Seite`
};

const en_pagination__aria_labels__prev = /** @type {(inputs: {}) => string} */ () => {
	return `Previous page`
};

const es_pagination__aria_labels__prev = /** @type {(inputs: {}) => string} */ () => {
	return `Página anterior`
};

const fr_pagination__aria_labels__prev = /** @type {(inputs: {}) => string} */ () => {
	return `Page précédente`
};

const it_pagination__aria_labels__prev = /** @type {(inputs: {}) => string} */ () => {
	return `Pagina precedente`
};

const nl_pagination__aria_labels__prev = /** @type {(inputs: {}) => string} */ () => {
	return `Vorige pagina`
};

const pt_pagination__aria_labels__prev = /** @type {(inputs: {}) => string} */ () => {
	return `Página anterior`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__prev = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pagination__aria_labels__prev(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pagination__aria_labels__prev", locale)
	if (locale === "de") return de_pagination__aria_labels__prev(inputs)
	if (locale === "en") return en_pagination__aria_labels__prev(inputs)
	if (locale === "es") return es_pagination__aria_labels__prev(inputs)
	if (locale === "fr") return fr_pagination__aria_labels__prev(inputs)
	if (locale === "it") return it_pagination__aria_labels__prev(inputs)
	if (locale === "nl") return nl_pagination__aria_labels__prev(inputs)
	return pt_pagination__aria_labels__prev(inputs)
};